import { Component } from '@angular/core';

@Component({
  selector: 'caremoni-blank-tv',
  template: '',
})
export class BlankTvComponent { }
